import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EventRow, FollowUp } from '../../styles/style';
import { setSelectedEvent } from '../../actions/events';
import { capacityToHuman } from '../../helpers/enums';

class Event extends Component {
  handleClick = () => {
    this.props.onClick(this.props.event);
  }
  render() {
    const { selected } = this.props;
    const { name, follow_up, organization_name, postal_code, area, capacity, swag_guests } = this.props.event;
    return (
      <EventRow onClick={this.handleClick} selected={selected}>
        <div className="name">
          <div>
            {follow_up === true && <FollowUp/>}
            {name}
          </div>
          <div>{organization_name}&nbsp;</div>
        </div>
        <div className="area">{area}</div>
        <div className="guests">
          <div>{capacityToHuman[capacity]}</div>
          {swag_guests && (<div>{Math.ceil(parseInt(swag_guests.split('-').pop(), 10) / 12)} swag bags</div>)}
        </div>
      </EventRow>
    )
  }
}

export default Event;
